import { Routes } from '@angular/router';
import { CanDeactivateGuard } from 'src/app/shared/helpers/canDeactivate';
import { EmptyComponent } from '../../../shared/components/empty.component';
import { firstNoteRedirectGuard } from './first-note-redirect.guard';
import { NotesViewerComponent } from './notes-viewer/notes-viewer.component';

export const NoteRoutes: Routes = [
  {
    path: '',
    component: EmptyComponent,
    canActivate: [firstNoteRedirectGuard],
  },
  {
    path: ':id',
    component: NotesViewerComponent,
    canDeactivate: [CanDeactivateGuard],
  },
];
